import "./App.css";
import React from "react";
import WorkflowText from "./components/WorkflowText";
import WorkflowImage from "./components/WorkflowImage";
import "./App.css";

function App() {
  return (
    <div className="app">
      <h1>AI Creative Studio</h1>

      <div className="card">
        <WorkflowText />
      </div>

      <div className="card">
        <WorkflowImage />
      </div>
    </div>
  );
}

export default App;
